(() => {
  'use strict';
  // Booking bridge disabled: preserve the page's native direct Square links.
})();
